import { render, staticRenderFns } from "./DispensersAndDevicesWidget.vue?vue&type=template&id=0b12e3f4"
import script from "./DispensersAndDevicesWidget.vue?vue&type=script&lang=js"
export * from "./DispensersAndDevicesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports